import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeSeemormb', function () {
        const el = $(this);
        return {
            swiperOptionFive: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {},
                },
            },
            localName: window.Shopify.locale,
            init() {
                this.initMB()
            }, // end init
            initMB() {
                this.initMBSwiper()
            },
            initMBSwiper() {
                new Swiper('.swiper-container-seemor-mb', this.swiperOptionFive)
            },
        }
    })
}
document.addEventListener('alpine:init', main)